export function isAnnualSponsorship(item) {
    return item?.type === "AnnualSponsorship";
}
export function isSilverSponsorship(item) {
    return item?.type === "SilverSponsorship";
}
export function isGoldSponsorship(item) {
    return item?.type === "GoldSponsorship";
}
export function isPlatinumSponsorship(item) {
    return item?.type === "PlatinumSponsorship";
}
//# sourceMappingURL=annual-sponsorship.js.map